import { supabase } from "../supabase/client";

export async function createReservationBatch(rows, summaries, targetTable = "reservations") {
  if (!["reservations", "tentative_reservations"].includes(targetTable)) {
    return { error: new Error("Invalid reservation table") };
  }
  try {
    return await supabase.rpc("create_reservation_batch", {
      p_rows: rows,
      p_summaries: targetTable === "reservations" ? summaries : [],
      p_tentative: targetTable === "tentative_reservations",
    });
  } catch (error) {
    return { error };
  }
}
